import React from 'react';
import { motion } from 'framer-motion';
import { Car, Heart, Calendar, UtensilsCrossed, Video, Camera } from 'lucide-react';
import { portfolioData } from '../data/mock';

const iconMap = { Car, Heart, Calendar, UtensilsCrossed, Video, Camera };

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.25, 1, 0.5, 1] }
  })
};

const bentoSpans = [
  'md:col-span-7 md:row-span-2',
  'md:col-span-5',
  'md:col-span-5',
  'md:col-span-4',
  'md:col-span-4',
  'md:col-span-4',
];

const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 lg:py-40 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="mb-16"
        >
          <motion.p variants={fadeUp} custom={0} className="text-xs md:text-sm uppercase tracking-[0.3em] font-medium text-white/40 mb-4">
            What I Do
          </motion.p>
          <motion.h2 variants={fadeUp} custom={1} className="font-serif text-4xl sm:text-5xl md:text-6xl font-light tracking-tight leading-tight text-white">
            Services
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5"
        >
          {portfolioData.services.map((service, i) => {
            const Icon = iconMap[service.icon] || Camera;
            return (
              <motion.div
                key={service.id}
                variants={fadeUp}
                custom={i}
                data-testid={`service-card-${service.id}`}
                className={`${bentoSpans[i] || 'md:col-span-4'} group relative overflow-hidden border border-white/5 hover:border-white/20 transition-all duration-500 ${i === 0 ? 'min-h-[280px] md:min-h-[400px]' : 'min-h-[220px] md:min-h-[220px]'}`}
              >
                <img
                  src={service.bgImage}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover grayscale opacity-30 group-hover:grayscale-0 group-hover:opacity-40 transition-all duration-700 scale-105 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" />
                <div className="relative z-10 p-6 md:p-8 h-full flex flex-col justify-end">
                  <Icon className="w-6 h-6 text-white/40 mb-4 group-hover:text-white/70 transition-colors duration-500" />
                  <h3 className="font-serif text-xl md:text-2xl font-light tracking-tight text-white mb-2">
                    {service.title}
                  </h3>
                  <p className="text-sm font-light text-white/50 leading-relaxed group-hover:text-white/70 transition-colors duration-500">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
